import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99999;
`;

export const Content = styled.div`
  display: flex;
  background: #fff;
  width: auto;
  height: auto;
  border-radius: 5px;
  padding: 10px;

  @media (max-width: 600px) {
    flex-direction: column;
    margin: 0 10px;
    width: 85%;
    overflow-y: auto;
  }
`;

export const ContentModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;

  h2 {
    font-size: 18px;
    padding-bottom: 10px;
  }

  h3:first-of-type {
    color: #455a64;
  }

  h3 {
    font-size: 18px;
		font-weight: 500;
    color: #546e7a;
    padding-bottom: 10px;
  }

	span {
		color: #2196f3;
	}

  button {
    border-radius: 10px;
    width: 100%;
    padding: 15px;
    margin-top: 10px;
  }

  .button-adicionar {
    background-color: #2196f3;
		font-size: 18px;
		font-weight: 600;
		color: #fff;
    border: 2px solid #2196f3;
  }

  .button-cancel {
    background-color: #fff;
		font-size: 18px;
		font-weight: 600;
		color: #2196f3;
    border: 2px solid #2196f3;
  }
`;
